import { createSelector } from "reselect";
import { getResourceUsage } from "../reducers/app/entities/runs";
import { AppState } from "../types";
import { getCurrentKernelRunId } from "./current";

/** Selects the notebook state. */
export const getNotebook = (state: AppState) => state.notebook;

/** Selects the accelerator enabled for the notebook. */
export const getAccelerator = createSelector(
  [getNotebook],
  notebook => notebook.accelerator
);

/** Selects the showAcceleratorUnusedCallout. */
export const getShowAcceleratorUnusedCallout = createSelector(
  [getNotebook],
  notebook => notebook.showAcceleratorUnusedCallout
);

/** Selects the language id enabled for the notebook. */
export const getLanguageId = createSelector(
  [getNotebook],
  notebook => notebook.languageId
);

export const getQueuePosition = createSelector(
  [getNotebook],
  notebook => notebook.queuePosition
);

export const getSaveStatus = createSelector(
  [getNotebook],
  notebook => notebook.saveStatus
);

export const getEntities = (state: AppState) => state.entities;

/** Selects the accelerator wastated sate for kernel run. */
export const getIsAcceleratorWasted = createSelector(
  [getAccelerator, getCurrentKernelRunId, getEntities],
  (accelerator, kernelRunId, entities) => {
    const resourceUsage = getResourceUsage(entities.runs, kernelRunId);
    if (
      !kernelRunId ||
      !resourceUsage ||
      accelerator === "none" ||
      !resourceUsage.acceleratorEverUtilized
    ) {
      // Conservatively assume that accelerator is NOT wasted.
      return false;
    }
    return !resourceUsage.acceleratorEverUtilized?.everUtilized;
  }
);
